import { Button } from 'antd';
import styled from 'styled-components';

export const StyledButton = styled(Button)`
  .IconViewFilled {
    fill: ${({ theme, disabled }) => (disabled ? theme.colors.black4 : theme.colors.black9)};
  }
  .IconViewOffFilled {
    fill: ${({ theme, disabled }) => (disabled ? theme.colors.black4 : theme.colors.black9)};
  }
`;

export const ButtonText = styled.span`
  color: ${({ theme }) => theme.colors.black9};
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  .ant-btn {
    span {
      font-weight: 400 !important;
    }
  }
`;
